import React from "react";
import { NavWrap } from "../ShopForTyres";
import CollectKyc from "./CollectKyc";
import "./customers.css";
import AdminsTable from "./AdminsTable";

const Admins = () => {
  return (
    <NavWrap>
      <div className="customers showTyresFilters admin">
        <div className="head">
          <h3>Admins</h3>
        </div>
        <AdminsTable />
        <CollectKyc />
      </div>
    </NavWrap>
  );
};

export default Admins;
